var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/FieldPass/Footer.js";
var _excluded = ["buttonProps", "componentKey", "label", "onClick", "shape"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import Button from "@mlb/react-patterns/dist/components/Button/button";
import { ButtonShapes } from "@mlb/react-patterns/dist/components/Button/button.types";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import React from "react";
import styled from "styled-components";
export var FooterContainer = styled.div.withConfig({
  displayName: "Footer__FooterContainer",
  componentId: "sc-ank5u2-0"
})(["border-top:1px solid ", ";display:grid;height:80px;padding:8px;place-items:center;"], COLORS.mlbGrey2);
var StyledButton = styled(Button).withConfig({
  displayName: "Footer__StyledButton",
  componentId: "sc-ank5u2-1"
})(["align-items:center;border-radius:60px;display:flex;font-size:16px;height:48px;justify-content:center;min-width:208px;&[data-focus-visible-added]{box-shadow:0 0 0 3px rgba(0,137,255,0.65);outline:none;}"]);
var Footer = function Footer(_ref) {
  var buttonProps = _ref.buttonProps,
    componentKey = _ref.componentKey,
    label = _ref.label,
    onClick = _ref.onClick,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? ButtonShapes.PILL : _ref$shape,
    props = _objectWithoutProperties(_ref, _excluded);
  var dataAttrCloseButton = {
    "data-testid": "".concat(componentKey, "__footer-button")
  };
  return /*#__PURE__*/React.createElement(FooterContainer, _extends({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(StyledButton, _extends({
    dataAttr: dataAttrCloseButton,
    handlers: {
      onClick: onClick
    },
    shape: shape
  }, buttonProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }), label));
};
export default /*#__PURE__*/React.memo(Footer);